module.exports = __webpack_public_path__ + "static/media/f-twt.b5d858ff.svg";